module.exports = __webpack_public_path__ + "009914699c3a40f9b7e654c18ad5cafa.svg";